<template>
  <div v-if="org">
    <div class="details-card__title details-card__title--main d-flex mb-6">
      <div>Organisation</div>
      <apio-icon 
        name="ui-edit"
        class="edit-icon"
        @click.native="editOrganisation"
        lightModeColour="black"
        darkModeColour="white"
      />
    </div>

    <!-- Organisation -->
    <div class="details-card__title mb-2">{{ org.name }}</div>
    <div
      v-if="
        !org.contact_name && !org.contact_email && !org.contact_number
      "
      class="details-card__body--text"
    >
      No organisation details specified
    </div>
    <div class="details-card__body">{{ org.contact_name }}</div>
    <div class="details-card__body">{{ org.contact_email }}</div>
    <div class="details-card__body mb-6">{{ org.contact_number }}</div>
    <!-- End of Organisation -->

    <!-- Address -->
    <div class="details-card__title mb-2">Address</div>
    <div
      v-if="
        !org.address_line_1 && !org.address_line_2 && !org.city && !org.postcode && !country
      "
      class="details-card__body"
    >
      No address specified
    </div>
    <div class="details-card__body">{{ org.address_line_1 }}</div>
    <div class="details-card__body">{{ org.address_line_2 }}</div>
    <div class="details-card__body">
      {{ org.city }}<span v-if="org.city && org.postcode">,</span>
      {{ org.postcode }}
    </div>
    <div class="details-card__body">{{ country }}</div>
    <!-- End of Address -->
  </div>
</template>

<script>
export default {
  props: {
    org: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    country() {
      if (!this.org.country) return;
      return this.org.country[0].name;
    }
  },
  methods: {
    editOrganisation() {
      this.$emit('edit-org')
    }
  }
};
</script>